import jwt_decode, { JwtPayload } from "jwt-decode";

export type AegisTokens = {
  access_token: string;
  id_token: string;
  refresh_token?: string;
  expires_in: number;
  redirect_uri?: string;
  original_state?: string;
  authorization_code?: string;
};

export const storeAegisTokens = (tokens: AegisTokens): void => {
  localStorage.setItem("aegis_access_token", tokens.access_token);
  localStorage.setItem("aegis_id_token", tokens.id_token);
  localStorage.setItem("aegis_refresh_token", tokens.refresh_token || "");
  localStorage.setItem(
    "aegis_expires_at",
    String(Date.now() + tokens.expires_in * 1000)
  );
};

export const clearAegisTokens = (): void => {
  localStorage.removeItem("aegis_id_token");
  localStorage.removeItem("aegis_access_token");
  localStorage.removeItem("aegis_refresh_token");
  localStorage.removeItem("aegis_expires_at");
};

export const getKCClientIDFromIDToken = (idToken: string): string | null => {
  try {
    const payload = jwt_decode<JwtPayload & { azp?: string }>(idToken);
    return payload.azp || null;
  } catch {
    return null;
  }
};

export const refreshAegisTokens = async (): Promise<boolean> => {
  const idToken = localStorage.getItem("aegis_id_token");
  const refreshToken = localStorage.getItem("aegis_refresh_token");
  if (!idToken || !refreshToken) return false;
  const kcClientID = getKCClientIDFromIDToken(idToken);
  if (!kcClientID) return false;
  try {
    const r = await fetch("/oauth2/aegis/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kc_client_id: kcClientID,
        refresh_token: refreshToken,
      }),
    });
    if (!r.ok) return false;
    const tokens: AegisTokens = await r.json();
    storeAegisTokens(tokens);
    return true;
  } catch {
    return false;
  }
};
